import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	videoThumbnailAltText: {
		id: 'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text',
		defaultMessage: 'Video thumbnail',
		description: 'Video thumbnail alt text',
	},
	videoIconLabel: {
		id: 'dynamic-cards-search-page.video-search-result.video-icon-label',
		defaultMessage: 'video icon',
		description: 'Video icon label',
	},
	dropdownMessage: {
		id: 'dynamic-cards-search-page.video-search-result.dropdown-message',
		defaultMessage:
			'{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
		description: 'Dropdown message for video search result',
	},
});
